import React, { Component } from 'react'
import NakedItemArticle, { Description0NakedItemArticle, Image0NakedItemArticle } from '../../views/NakedItemArticle'
import styled from 'styled-components'
import { Wrapper0TextItemArticle } from '../../components/DescriptionItemArticle/components/TextItemArticle'
import { Title0TitleItemArticle } from '../../components/DescriptionItemArticle/components/TitleItemArticle'
import { LinkHeadLine0TopLine } from '../../../../../../components/TopLine'
import { TopLine0DescriptionItemArticle } from '../../components/DescriptionItemArticle'

const Wrapper = styled.div``

const StyledNakedItemArticle = styled(NakedItemArticle)`
  min-width: 100%;
  position: relative;
  ${Image0NakedItemArticle} {
    width: 100%;
  }
  ${Description0NakedItemArticle} {
    min-width: 90%;
    padding-top: calc(${(props) => props.theme.sizes.gapColHalf} / 2);
    padding-bottom: 20px;
    position: absolute;
    background-color: transparent;
    bottom: 0px;
    left: ${(props) => props.theme.sizes.gapColHalf};
    right: ${(props) => props.theme.sizes.gapCol};
    z-index: 2;
  }
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    ${Description0NakedItemArticle} {
      padding-top: calc(${(props) => props.theme.tablet.sizes.gapColHalf} / 2);
      left: ${(props) => props.theme.tablet.sizes.gapColHalf};
      right: ${(props) => props.theme.tablet.sizes.gapCol};
    }
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    ${Description0NakedItemArticle} {
      padding-top: calc(${(props) => props.theme.mobile.sizes.gapColHalf} / 2);
      left: ${(props) => props.theme.mobile.sizes.gapColHalf};
      right: ${(props) => props.theme.mobile.sizes.gapCol};
    }
  }
  ${Wrapper0TextItemArticle} {
    display: none;
  }
  ${Title0TitleItemArticle} {
    color: #fff;
    text-shadow: 1px 1px 2px #000;
    z-index: 2;
  }
  ${LinkHeadLine0TopLine} {
    color: #fff;
    text-shadow: 1px 1px 2px #000;
  }
  ${TopLine0DescriptionItemArticle} {
    display: none;
  }
`

class VideoItemArticle extends Component {
  render() {
    const { video, headline, title, image, local, partner, type, url, ...props } = this.props
    return (
      <Wrapper {...props}>
        <StyledNakedItemArticle
          {...props}
          video={video}
          url={url}
          local={local}
          partner={partner}
          type={type}
          image={image}
          inverted_background_color="backgroundSecondary"
          headline={headline}
          title={title}
          department={undefined}
          moreLink={false}
        />
      </Wrapper>
    )
  }
}

VideoItemArticle.propTypes = {
  ...NakedItemArticle.propTypes,
}

VideoItemArticle.defaultProps = {
  truncateText: {
    numberOfLines: 'auto',
  },
  truncateTitle: {
    numberOfLines: 3,
  },
}

export default VideoItemArticle
export { Wrapper as Wrapper0VideoItemArticle }
